import api from "../lib/api";
import { getCategorySlug, getProductCategories } from "../lib/utils-cynos";

export const DEFAULT_COLOR_FILTERS = ["Black", "White", "Navy Blue", "Beige", "Charcoal", "Red"];

export const buildProductParams = ({ category, size, color, sort, maxPrice, search } = {}) => {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (size) params.size = size;
  if (color) params.color = color;
  if (sort) params.sort = sort;
  if (maxPrice && maxPrice < 2000) params.max_price = maxPrice;
  if (search) params.search = search;
  return params;
};

export const collectProductColors = (products) => {
  const seen = new Set();
  const colors = [];
  products.forEach((product) => {
    (product.colors || []).forEach((raw) => {
      const color = String(raw || "").trim();
      const key = color.toLowerCase();
      if (color && !seen.has(key)) {
        seen.add(key);
        colors.push(color);
      }
    });
  });
  return colors.length ? colors.sort((a, b) => a.localeCompare(b)) : DEFAULT_COLOR_FILTERS;
};

export const listProducts = async (filters = {}) => {
  const { data } = await api.get("/products", { params: buildProductParams(filters) });
  return data;
};

export const listBestsellers = async () => {
  const { data } = await api.get("/products/bestsellers");
  return data;
};

export const getProductBySlug = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};

export const listRelatedProducts = async (product) => {
  const firstCategory = getProductCategories(product)[0] || product.category;
  const data = await listProducts({ category: getCategorySlug(firstCategory) || product.category });
  return data.filter((item) => item.slug !== product.slug).slice(0, 4);
};
